/* sb-dc-home.js — 앱바의 로고와 «Design Center» 글씨에 링크 노릇을 붙인다.

     로고(.brand-mark)          → 스토어 홈            /
     «Design Center»(.brand-name i) → 디자인 템플릿 페이지  /pages/design-templates

   이 자리는 647KB 번들(sb-dc-app.js)이 React 로 그리는 <div> 라 진짜 <a> 로
   바꿀 수가 없다. 번들은 손대지 않고 여기서 붙인다 — 마우스 클릭, 키보드
   (Enter·Space), 스크린리더(role=link) 모두 동작한다.

   주소는 Shopify.routes.root 기준(sb-dc-cartnav.js 와 같은 방식). 실제
   스토어에서는 stickersbanners.com 이고, 테마 미리보기(.myshopify.com)에서는
   미리보기 밖으로 튕겨 나가지 않는다.

   «Design Center» 는 로고를 감싼 .brand 안에 들어 있으므로 그 클릭은
   stopPropagation 으로 막는다 — 안 막으면 홈으로도 같이 가려 한다.

   React 가 헤더를 다시 그려도 같은 DOM 노드를 재사용하므로 여기서 건 속성과
   리스너는 그대로 남는다. */
(function () {
  'use strict';

  /* 실제 스토어·테마 미리보기에서는 Shopify.routes.root 가 항상 있다(실제 페이지에서
     확인: Shopify.routes.root = "/"). 그게 없는 곳은 로컬 미리보기.html(file://)
     뿐이고, 거기서 '/' 로 가면 file:/// 이라 아무것도 안 나온다 — 그때만 실제
     주소를 쓴다. 그래야 로컬에서도 눌러 보고 확인할 수 있다. */
  var SITE = 'https://stickersbanners.com/';

  function root() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (r) return r;
    } catch (e) {}
    return SITE;
  }

  function link(el, path, label) {
    el.setAttribute('role', 'link');
    el.setAttribute('tabindex', '0');
    el.setAttribute('title', label);
    el.style.cursor = 'pointer';
    function go(e) {
      e.stopPropagation();            // 안쪽(Design Center)이 바깥(로고)까지 부르지 않게
      window.location.href = root() + path;
    }
    el.addEventListener('click', go);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(e); }
    });
  }

  var tries = 0;
  var timer = setInterval(function () {
    var brand = document.querySelector('.appbar .brand');
    var name = brand && brand.querySelector('.brand-name i');
    if (brand && name) {
      clearInterval(timer);
      link(brand, '', 'Back to StickersBanners.com');
      link(name, 'pages/design-templates', 'Browse design templates');
    } else if (++tries > 100) {        // 20초 (200ms × 100) 뒤 포기
      clearInterval(timer);
    }
  }, 200);
})();
